import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { applyTheme } from './applyTheme';
import { readStoredThemeId, THEME_STORAGE_KEY, THEMES } from './themeConfig';

const ThemeContext = createContext(null);

export function ThemeProvider({ children }) {
  const [themeId, setThemeIdState] = useState(() => readStoredThemeId());

  const setThemeId = useCallback((id) => {
    const valid = THEMES.some((t) => t.id === id) ? id : readStoredThemeId();
    setThemeIdState(valid);
    applyTheme(valid);
    try {
      localStorage.setItem(THEME_STORAGE_KEY, valid);
    } catch {
      /* ignore */
    }
  }, []);

  const value = useMemo(
    () => ({
      themeId,
      themes: THEMES,
      setThemeId,
    }),
    [themeId, setThemeId],
  );

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
}

export function useTheme() {
  const ctx = useContext(ThemeContext);
  if (!ctx) {
    throw new Error('useTheme must be used within ThemeProvider');
  }
  return ctx;
}
